
if (!customElements.get('infinity-scroll')) {
    customElements.define('infinity-scroll', class InfinityScroll extends HTMLElement {
        constructor() {
            super();
            this.settings = {
                pagination: this.getAttribute('pagination'),
                method: this.getAttribute('method'),
                container: this.getAttribute('container'),
                offset: 0,
                loadingText: this.getAttribute('loadingText'),
                btnTitle: this.getAttribute('btnTitle'),
                btnPrevTitle: this.getAttribute('btnPrevTitle'),
                prevBtn: '#PreviousPage',
                callback: null
            };
            this.loadingMoreItems = false;

            if (document.querySelector('.product-grid-container .collection:last-child .pagination-loader')) {
                this.settings.method = 'scroll';
            } else {
                this.settings.method = 'click';
            }
            
            document.querySelector('body').classList.add('infinity-loop-enabled')
            this.allPaginations = null;
            this.pagesAdded = [];
            let lastPage = this.getAttribute('lastPageNum');
            this.loadingBtn = false;
            this.currentPage = parseInt(this.getAttribute('currentPage'));
            this.pageIndex = this.currentPage;
            this.currentPageview = null;

            this.addScrollListeners = this.addScrollListeners.bind(this);
            this.addClickListener = this.addClickListener.bind(this);
            this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
            this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
            
            this.destroy = this.destroy.bind(this);
            

            // Set up our element selectors
            this.containerElement = document.querySelector(this.settings.container);
            this.paginationElement = document.querySelector(this.settings.pagination);
            window.pagination = {};
            
            this.initialize();

            
        }

        saveScrollPosition(){
            let itemClicked = event.currentTarget;
            let container = document.querySelector(this.settings.container);
            if (itemClicked) {
                
                let data = {
                    id: itemClicked.getAttribute('id'),
                    top: container.scrollTop - document.body.scrollTop
                };
            
                localStorage.setItem('last-seen',  JSON.stringify(data));
            }
            
        }
       
        initialize() {
            if (this.containerElement) {
                var initializers = {
                    click: this.addClickListener,
                    scroll: this.addScrollListeners
                };
                if (this.id == 'PreviousPage') {
                    this.addClickListener();
                } else {
                    initializers[this.settings.method]();
                }
                
                // document.querySelectorAll('li[id^=Product-]').forEach((item) => {
                //     item.addEventListener('click', this.saveScrollPosition.bind(this));
                // });
                this.observeCollectionPages();  
                
            }
        }

        /**
         *  Observe collections that added to the DOM and update URL to current page viewed
         */
        observeCollectionPages(){
            const collections = document.querySelectorAll('div.collection');
            const options = {
                threshold: 0.1
             };
            const collectionObserver = new IntersectionObserver((entries, observer) => { 
                entries.forEach(entry => {
                    let count = entries.length;
                    
                    if (entry.isIntersecting) {
                        const collection = entry.target;
                        const currentPageIndex = parseInt(collection.getAttribute('page'));
                        this.currentPageview = currentPageIndex;
                        let url = new URL(window.location.href);
                        url.searchParams.set('page',currentPageIndex);
                        history.pushState(null,'Page' + currentPageIndex, url.href);
                        
                        if (!this.pagesAdded.includes(currentPageIndex)) {
                            this.pagesAdded.push(currentPageIndex);
                        }                
                    }
                });
            }, options);
        
            if (collections.length) {
                collections.forEach((collection)=> {
                    collectionObserver.observe(collection);
                });
            }
             

        }

        addScrollListeners() {
            
            if (this.paginationElement) {
                
                let pagination = document.querySelector(".product-grid-container .collection:last-child .pagination-loader");
                if (!pagination) {
                    return;
                }
                let options = {
                   threshold: 0.1,
                };
                let observer = new IntersectionObserver( entries => {
                    let entry = entries[0];
                    if( entry.isIntersecting ) {
                        this.checkIfPaginationInView();
                        observer.unobserve(pagination);
                    }else {
                        // Direct land on page with hash key
                        // TODO:  change hash to URL param
                        let url = new URL(window.location.href);
                        
                        var visiblepage =  url.searchParams.get('page');
                        
                        if (visiblepage) {
                            let pages = document.querySelectorAll('.page-num');
                            if (pages.length) {
                                const pagesObserver = new IntersectionObserver( (entries) => {
                                    let entry = entries[0];
                                    if (entry.isIntersecting) {
                                        let elm = entry.target;
                                        let ind = elm.getAttribute('id');
                                        if (ind == 'pageNaN') {
                                            ind = 1;
                                        }else{
                                          ind = ind.replace('page','');
                                        }
                                        
                                        let url = new URL(window.location.href);
                                        url.searchParams.set('page',ind);
                                        history.pushState(null,'Page' + visiblepage, url.href)
                                    }
                           
                                },{
                                    threshold: 0.1,
                                });
                                pages.forEach( page => {
                                    pagesObserver.observe(page);
                                })
                } else {
                    // // user arrived with direct "hashed" page URL
                    // let currentPage = this.querySelector('a').getAttribute('nextpageurl');
                    // currentPage = currentPage.replace('?page=2','?page=' + visiblepage);
                    // this.nextPageUrl = currentPage;
                    // return this.loadMore(visiblepage);
                }
            } 
                    }
                    
                }, options);
                observer.observe(pagination);
            }
        }

        hideAllLoaders(showLast) {
            let allLoaders = this.containerElement.querySelectorAll('.collection .pagination-loader');
            allLoaders.forEach((elm, idx) => {

                if (idx === allLoaders.length - 1 && showLast) {
                    return;
                }
                elm.style.display = "none";
            });
        }

        addClickListener() {
            let allPaginations = document.querySelectorAll('.infinite-loop');
            
            
            allPaginations.forEach((pager)=> {
                this.nextPageLinkElement = pager.querySelector('a');
                if (this.nextPageLinkElement) {
                    this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks.bind(this));     
                }
                
            })
                
        }
        
        /*
        * Click handler
        */
        stopMultipleClicks() {
            event.preventDefault();
            let element = event.target;
            let clickActive = element.getAttribute('clickActive')
            if (element && clickActive == 1) {
                
                element.textContent = this.settings.loadingText;
                this.loadingBtn = element.parentElement;
                this.nextPageUrl = element.href;
                this.direction = element.getAttribute('direction');
                element.setAttribute('clickActive', 0) ;
                let pageIndex = parseInt(element.getAttribute('data-num'))
                if (!this.pagesAdded.includes(pageIndex)) {
                    this.loadMore(pageIndex, this.direction ,element);
                    this.pagesAdded.push(pageIndex);
                }
                   
            }
        }

        hideLoadingButton(element) {
            return element.classList.add('loaded');
        }

        checkIfPaginationInView() {
            
            var throttleTimer;
            const throttle = (callback, time) => {
                if (throttleTimer) return;
                throttleTimer = true;
                setTimeout(() => {
                    callback();
                    throttleTimer = false;
                }, time);
            };


            this.paginationElement = document.querySelector('.product-grid-container .collection:last-child .infinite-loop');
            if (this.paginationElement.querySelector('a')) {
                
                throttle(() => {
                            
                    this.nextPageLinkElement = this.paginationElement.querySelector('a');
                    
                    if (this.nextPageLinkElement) {
                        let pageIndex = parseInt(this.nextPageLinkElement.getAttribute('data-num'));
                   
                        this.nextPageUrl = this.nextPageLinkElement.href;
                        if (isNaN(this.currentPage)) {
                             this.currentPage = pageIndex - 1;
                        }    
                     
                        if (!this.pagesAdded.includes(pageIndex) && (pageIndex - 1 == this.currentPage) ) {
                            
                            this.loadingMoreItems = true;
                            this.loadMore(pageIndex, 'next');
                            this.pagesAdded.push(pageIndex);
                        }
                    }
                }, 2000)
            }
       
        }

        remove(collections){
            collections.forEach((collection, ind, arr) => {
                collection.remove();
            });
        }

        unload(direction, pageIndex){
            
            if (!pageIndex > 3) {
                return;
            }
            
            const totalPagesToRemove = 2;
            var collections = document.querySelectorAll('#ProductGridContainer .collection');
            if (collections.length > (totalPagesToRemove + 1)) {
                if (direction == 'next') {
                    collections = document.querySelectorAll('#ProductGridContainer .collection:nth-child(-n+ ' + totalPagesToRemove + ')');
                }else {
                    collections = document.querySelectorAll('#ProductGridContainer .collection:nth-last-child(-n+ ' + totalPagesToRemove + ')');
                }
                this.allPaginations = document.querySelectorAll('.infinite-loop');
                let prevIndex = pageIndex - totalPagesToRemove;
                this.pagesAdded = [];
                this.allPaginations.forEach((pagination)=>{

                    if (pagination.classList.contains('p-' + prevIndex)){
                        pagination.querySelector('a').style.display = 'flex';
                        pagination.querySelector('a').setAttribute('clickactive', 1);
                        pagination.querySelector('a').setAttribute('direction', 'prev');
                        pagination.querySelector('a').textContent = this.settings.btnPrevTitle;
                        pagination.querySelector('a').classList.add('button','default')
                        document.querySelector('#PreviousPage').innerHTML = pagination.outerHTML; 
                        
                    }
                });

                this.remove(collections);

                document.querySelectorAll('.product-grid-container .collection').forEach( (collection) => {
                    var i = collection.getAttribute('page');
                    this.pagesAdded.push(i);
                });
                if (document.querySelector('#ProductGridContainer .collection:last-child .pagination-loader')) {
                    this.addScrollListeners();
                }else {
                    this.addClickListener();
                }
                
            }
            
        }

        /**
         * 
         *  Handle grid content 
         * 
         */
          loadMore(pageIndex, direction , btnClicked) {
            
            if (isNaN(pageIndex)) {
                return false;
            }
            
            this.request = new XMLHttpRequest();
            this.request.onreadystatechange = function () {
                if (this.request.readyState === 4 && this.request.status === 200) {
                    
                    let newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
                    this.allPaginations = this.request.responseXML.querySelectorAll(this.settings.pagination);
                    let prevBtn = this.request.responseXML.querySelectorAll(this.settings.prevBtn)[0];
                    let pager = document.createElement('div');
                    let p = document.createElement('p');
                    let showLastLoader = true;
                   console.log('newContainer : ', newContainer);
                    
                    if (direction == 'next') {
                        let lastUL = this.containerElement.querySelector('ul:last-of-type');
                        let newLIs = newContainer.querySelectorAll('li');
                        let newBtn = newContainer.querySelector('button');
                        let newLink = newContainer.querySelector('link');
                        let newPaginationWrapperDiv = newContainer.querySelector('div.pagination-wrapper');
                        let currentBtn = this.containerElement.querySelector('button');
                        let currentLink = this.containerElement.querySelector('link');
                        let currentPaginationWrapperDiv = this.containerElement.querySelector('div.pagination-wrapper');
                        if (currentBtn && newBtn) currentBtn.replaceWith(newBtn.cloneNode(true));
                        if (currentLink && newLink) currentLink.replaceWith(newLink.cloneNode(true));
                        if (currentPaginationWrapperDiv && newPaginationWrapperDiv) 
                            currentPaginationWrapperDiv.replaceWith(newPaginationWrapperDiv.cloneNode(true));
                        newLIs.forEach(li => {
                            lastUL.insertAdjacentHTML('beforeend', li.outerHTML);
                        });
                    } else {
                        Array.from(newLIs).reverse().forEach(li => {
                            lastUL.insertAdjacentHTML('afterbegin', li.outerHTML);
                        });
                    }
                    if (prevBtn && direction != 'next') {
                        document.querySelector('#PreviousPage').innerHTML = prevBtn.outerHTML; 
                    }                    
                    if (this.allPaginations) {
                        this.allPaginations.forEach((paginate, ind, arr)=>{
                            if (ind === arr.length - 1) {
                                this.paginationElement = paginate.innerHTML;   
                            }
                        })
                    }

                     /* Needed to update the url after load */   
                   if (!isNaN(pageIndex)) {
                        let url = new URL(window.location.href);
                        let pageID = 'page'+pageIndex;
                        url.searchParams.set('page', pageIndex);
                        history.pushState(null, pageID, url.href);
                    }
      
                    
                    this.hideAllLoaders(showLastLoader);
                    if (this.loadingBtn) {
                        this.hideLoadingButton(this.loadingBtn);
                    }
                    if (this.settings.callback && typeof this.settings.callback === 'function') {
                        this.settings.callback(this.request.responseXML);
                    }
                    if (btnClicked) {
                        btnClicked.style.display = 'none';
                    }
                    
                    this.unload(direction, pageIndex);
                    this.initialize();
                }
            }.bind(this);

            this.request.open('GET', this.nextPageUrl);
            this.request.responseType = 'document';
            this.request.send();
        }

        removeClickListener() {
            this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
        }

     
        
        destroy() {
            // This method is used to unbind event listeners from the DOM
            // This function is called manually to destroy "this" Ajaxinate instance
            var destroyers = {
                click: this.removeClickListener
            };
            destroyers[this.settings.method]();
            return this;
        }
    });
}